import React from 'react'
import { TeamType } from 'types/team/team'

interface DetailsTabProps {
  team: TeamType
}

const DetailsTab: React.FC<DetailsTabProps> = ({ team }) => {
  return (
    <div style={{ padding: '24px 30px' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20, border: '1px solid #EBEDF1' }}>
        <h3 style={{ margin: '0 0 12px 0', fontSize: 16, fontWeight: 600 }}>About</h3>
        <p style={{ margin: 0, color: team.about ? '#000' : '#939598' }}>
          {team.about || 'No description provided'}
        </p>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 20, border: '1px solid #EBEDF1' }}>
        <h3 style={{ margin: '0 0 12px 0', fontSize: 16, fontWeight: 600 }}>Status</h3>
        <span style={{
          display: 'inline-block',
          background: team.status === 'active' ? '#f6ffed' : '#f5f5f5',
          color: team.status === 'active' ? '#52c41a' : '#939598',
          border: `1px solid ${team.status === 'active' ? '#b7eb8f' : '#d9d9d9'}`,
          borderRadius: 20, padding: '2px 12px', fontSize: 13,
        }}>
          {team.status === 'active' ? 'Active' : 'Archived'}
        </span>
      </div>

      {team.coverPhoto && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 20, border: '1px solid #EBEDF1' }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: 16, fontWeight: 600 }}>Cover Photo</h3>
          <img
            src={team.coverPhoto.original}
            alt="cover"
            style={{ width: '100%', borderRadius: 8, maxHeight: 200, objectFit: 'cover' }}
          />
        </div>
      )}
    </div>
  )
}

export default DetailsTab
